import { Grid, Tooltip } from '@mui/material';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { DelegacionFilter } from './DelegacionFilter';
import { ParametroFilterInput } from './ParametroFilterInput';

export const ConsultasGeneralesFilters = ({
    filters,
    handleChangeFilters,
    disableFilters,
    parametros = [],
    delegaciones,
    delegacionesLoading,
    selectedDelegaciones,
    onChangeSelectedDelegaciones,
    consultasOptions,
    consultaSelected,
    parametrosLoading,
    parametrosError,
    parametrosValues = {},
    onParametrosValuesChange
}) => {

    return (
        <Grid
            container
            spacing={2}
            sx={{ marginBottom: '25px' }}
        >
            <Grid size={{ xs: 12, sm: 6, lg: 2.5, xl: 2.5 }}>
                <label className='label'>Tipo de consulta</label>
                <RenderInputByTypeMobile
                    input={{
                        type: 'select',
                        displayName: 'Seleccione una consulta',
                        name: 'idConsulta',
                        key: `${filters?.idConsulta}-idConsulta`,
                        disabled: disableFilters,
                        options: consultasOptions
                    }}
                    value={filters.idConsulta}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            {consultaSelected?.hasOwnProperty('dataPrivacy') && <Grid size={{ xs: 12, sm: 6, lg: 2.5, xl: 2.5 }}>
                <label className='label'>DataPrivacy</label>
                <RenderInputByTypeMobile
                    input={{
                        type: 'custom_switch',
                        displayName: '',
                        name: 'dataPrivacy',
                        disabled: true
                    }}
                    value={consultaSelected.dataPrivacy}
                />
            </Grid>}
            <Grid size={12}>
                <label className='label'>Descripción</label>
                <label className='label'>{consultaSelected?.descripcion || "-"}</label>
            </Grid>
            <Grid size={12}>
                <label className='label'>Delegaciones</label>
                <DelegacionFilter
                    delegaciones={delegaciones}
                    delegacionesLoading={delegacionesLoading}
                    selectedDelegaciones={selectedDelegaciones}
                    onChangeSelectedDelegaciones={onChangeSelectedDelegaciones}
                    disableFilters={disableFilters}
                />
            </Grid>
            <Grid size={12}>
                <label className='label'>Parametros</label>
                {parametrosError && <label className='label' style={{ color: '#d32f2f' }}>Error al cargar parámetros: {parametrosError}</label>}
                {parametrosLoading && <label className='label'>Cargando parámetros...</label>}
                {!parametrosLoading && !parametrosError && parametros?.length === 0 && <label className='label'>-</label>}
                {!parametrosLoading && !parametrosError && parametros?.length > 0 && (
                    <Grid container spacing={2}>
                        {parametros.map((parametro) => (
                            <ParametroFilterInput
                                key={parametro.id}
                                parametro={parametro}
                                onParametrosValuesChange={onParametrosValuesChange}
                                disableFilters={disableFilters}
                                parametrosValues={parametrosValues}
                            />
                        ))}
                    </Grid>
                )}
            </Grid>
        </Grid >
    )
}